// 处理模板表格变化
export const handleTemplateTableChange = (
  pagination: any,
  filters: any,
  sorter: any,
  searchTemplateParams: any,
  setSearchTemplateParams: (params: any) => void,
  setSelectedTemplateIds: (fn: (prev: string[]) => string[]) => void,
) => {
  console.log('filters', filters)
  setSearchTemplateParams({
    ...searchTemplateParams,
    page: pagination.current,
    pageSize: pagination.pageSize,
    filterParams: {
      sortField: sorter.order === undefined ? undefined : sorter.field,
      sortOrder:
        sorter.order === 'descend'
          ? 'SortOrderDescending'
          : sorter.order === 'ascend'
          ? 'SortOrderAscending'
          : undefined,
      originType: filters.originType,
    },
  })
  // 保持选中状态
  setSelectedTemplateIds(prev => [...prev])
}

// 处理用例表格变化
export const handleCaseTableChange = (
  pagination: any,
  filters: any,
  sorter: any,
  caseValue: any,
  searchCaseParams: any,
  setSearchCaseParams: (params: any) => void,
  setSelectedCaseIds: (fn: (prev: string[]) => string[]) => void,
) => {
  console.log('filters', filters)
  const processedValue =
    caseValue.field === 'tagId'
      ? caseValue?.value
        ? (caseValue.value as string[])?.map(item => item.split('$').slice(1).join('$'))
        : undefined
      : caseValue.value
  setSearchCaseParams({
    ...searchCaseParams,
    page: pagination.current,
    pageSize: pagination.pageSize,
    filterParams: {
      sortField: sorter.order === undefined ? undefined : sorter.field,
      sortOrder:
        sorter.order === 'descend'
          ? 'SortOrderDescending'
          : sorter.order === 'ascend'
          ? 'SortOrderAscending'
          : undefined,
      ...filters,
      [caseValue.field]: processedValue,
    },
  })
  // 保持选中状态
  setSelectedCaseIds(prev => [...prev])
}
